import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { Shield, LayoutDashboard, Users, FileText, AlertTriangle, CreditCard, Settings, LogOut, Calendar, MessageSquare, BarChart, LayoutTemplate, Bell, UserCircle, Sun, Moon } from 'lucide-react';
import { AdminThemeProvider, useAdminTheme } from '../../context/AdminThemeContext';
const AdminLayoutContent = () => {
  const {
    theme,
    toggleTheme
  } = useAdminTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const links = [{
    icon: LayoutDashboard,
    label: 'Dashboard',
    path: '/admin'
  }, {
    icon: Shield,
    label: 'Verifications',
    path: '/admin/verification'
  }, {
    icon: AlertTriangle,
    label: 'Fraud Alerts',
    path: '/admin/fraud'
  }, {
    icon: FileText,
    label: 'Listings',
    path: '/admin/listings'
  }, {
    icon: Users,
    label: 'Users',
    path: '/admin/users'
  }, {
    icon: CreditCard,
    label: 'Finance',
    path: '/admin/finance'
  }, {
    icon: Calendar,
    label: 'Inspections',
    path: '/admin/inspections'
  }, {
    icon: MessageSquare,
    label: 'Messaging',
    path: '/admin/messaging'
  }, {
    icon: BarChart,
    label: 'Analytics',
    path: '/admin/analytics'
  }, {
    icon: LayoutTemplate,
    label: 'CMS',
    path: '/admin/cms'
  }, {
    icon: Bell,
    label: 'Notifications',
    path: '/admin/notifications'
  }, {
    icon: Settings,
    label: 'Settings',
    path: '/admin/settings'
  }];
  return <div className="min-h-screen flex bg-slate-50 dark:bg-[#0f172a] text-slate-900 dark:text-slate-200 transition-colors duration-200" data-id="element-95">
      {/* Sidebar */}
      <aside className="w-64 bg-white dark:bg-[#1e293b] border-r border-slate-200 dark:border-slate-700 hidden md:flex flex-col fixed h-full z-10 transition-colors duration-200" data-id="element-96">
        <div className="p-6 border-b border-slate-200 dark:border-slate-700" data-id="element-97">
          <div className="flex items-center gap-2" data-id="element-98">
            <div className="w-8 h-8 rounded bg-secondary flex items-center justify-center font-serif font-bold text-xl text-primary-900" data-id="element-99">
              A
            </div>
            <span className="font-serif font-bold text-xl tracking-tight text-slate-900 dark:text-white" data-id="element-100">
              AMU Admin
            </span>
          </div>
        </div>

        <div className="p-4 flex-grow overflow-y-auto" data-id="element-101">
          <nav className="space-y-1" data-id="element-102">
            {links.map(link => {
            const isActive = location.pathname === link.path || link.path !== '/admin' && location.pathname.startsWith(link.path);
            const Icon = link.icon;
            return <Link key={link.path} to={link.path} className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-secondary/20 text-secondary' : 'text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-slate-200'}`} data-id="element-103">
                  <Icon size={18} className={isActive ? 'text-secondary' : 'text-slate-500 dark:text-slate-400'} data-id="element-104" />
                  {link.label}
                </Link>;
          })}
          </nav>
        </div>

        <div className="p-4 border-t border-slate-200 dark:border-slate-700" data-id="element-105">
          <div className="flex items-center gap-3 mb-4 px-3" data-id="element-106">
            <div className="w-8 h-8 rounded-full bg-slate-200 dark:bg-slate-700 flex items-center justify-center text-slate-700 dark:text-white text-xs font-bold" data-id="element-107">
              SA
            </div>
            <div data-id="element-108">
              <div className="text-sm font-medium text-slate-900 dark:text-white" data-id="element-109">
                Super Admin
              </div>
              <div className="text-xs text-slate-500 dark:text-slate-400" data-id="element-110">
                admin@amu.ng
              </div>
            </div>
          </div>
          <button onClick={() => navigate('/admin/login')} className="flex items-center gap-3 px-3 py-2.5 w-full rounded-lg text-sm font-medium text-red-500 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-400/10 transition-colors" data-id="element-111">
            <LogOut size={18} data-id="element-112" />
            Logout
          </button>
        </div>
      </aside>
      {/* Main Content */}
      <main className="flex-grow md:ml-64 flex flex-col min-h-screen" data-id="element-113">
        <header className="bg-white dark:bg-[#1e293b] border-b border-slate-200 dark:border-slate-700 p-4 flex items-center justify-between sticky top-0 z-20 transition-colors duration-200" data-id="element-114">
          <div className="font-medium text-slate-900 dark:text-white md:hidden" data-id="element-115">
            AMU Admin
          </div>
          <div className="hidden md:flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400" data-id="element-116">
            <Shield size={14} className="text-success" data-id="element-117" /> Secure Session Active
          </div>
          <div className="flex items-center gap-4" data-id="element-118">
            <button onClick={toggleTheme} className="p-2 rounded-lg text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors" data-id="element-119">
              {theme === 'dark' ? <Sun size={20} data-id="element-120" /> : <Moon size={20} data-id="element-121" />}
            </button>
          </div>
        </header>

        <div className="p-6 md:p-8 flex-grow" data-id="element-122">
          <Outlet data-id="element-123" />
        </div>
      </main>
    </div>;
};
export const AdminLayout = () => <AdminThemeProvider data-id="element-124">
    <AdminLayoutContent data-id="element-125" />
  </AdminThemeProvider>;